import { render, staticRenderFns } from "./GalleryManager.vue?vue&type=template&id=22632869&scoped=true"
import script from "./GalleryManager.vue?vue&type=script&lang=js"
export * from "./GalleryManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22632869",
  null
  
)

export default component.exports